




















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import Swiper from 'swiper';

import RouteCard from '@/components/route-card.vue';
import { Route } from '@/models/route';


@Component({
    components: {
        RouteCard,
    },
})
export default class RouteCardSlider extends Vue {

    @Prop(Array) public routes: Route[];

    public swiper: Swiper;
    public activeIndex: number;

    public mounted() {
        // @ts-ignore
        this.swiper = this.$refs.routeslider.swiper as Swiper;

        // Prevent loading images when offline
        if (this.swiper.lazy && this.swiper.lazy.loadInSlide) {
            const loadInSlideF = this.swiper.lazy.loadInSlide;
            this.swiper.lazy.loadInSlide = (index) => {
                if (navigator.onLine) loadInSlideF(index);
            };
        }

        this.swiper.on('slideChange', this.slideChanged);
        this.swiper.on('tap', this.slideTapped);
    }

    @Watch('routes')
    public async onModelChanged() {
        await this.$nextTick();
        this.swiper.update();
        this.swiper.lazy.load();
    }

    public slideChanged() {
        this.activeIndex = this.swiper.activeIndex;
        this.$emit('slideChanged');
    }

    public slideTapped() {
        this.$emit('slideTapped');
    }

    public jumpToIndex(index: number) {
        this.swiper.slideTo(index);
    }
}
